// extracted by mini-css-extract-plugin
export default {"RootModal":"RootModal_RootModal__6PLoQ","wrapper":"RootModal_wrapper__g3I4Q"};